export const KEYS = {
  AUTH: 'AUTH',
  AUTH_INFO: 'AUTH_INFO',
  MODAL: 'MODAL',
  LOADING: 'LOADING',
  AFFILIATE: 'AFFILIATE',
};
